import { useMarblePositionLabel } from 'src/hooks/useMarblePositionLabel'

type Props = Readonly<{
  position: number
}>

export function MarblePositionLabel({ position }: Props) {
  const positionLabel = useMarblePositionLabel(position)

  return <>{positionLabel}</>
}
